import React from "react";
import classNames from "./input.module.css";
import Label from "../label/label";
import InputMask from "react-input-mask";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";

const InputElement = ({ select, label, ...props }) => {
  // const El = props.rows ? "textarea" :select?"select": InputMask;
  const El = props.rows ? "textarea" : select ? Autocomplete : InputMask;

  if (select) {
    const options = props.options || [];
    const sameValue = (a, b) => String(a) === String(b);
    // value verildiyse kutu kontrollü çalışır: kod değeri "" yapınca ekrandaki seçim de temizlenir.
    // Seçenekler henüz yüklenmediyse (ör. okul listesi) aynı değere sahip defaultValue gösterilir.
    const controlledProps =
      props.value === undefined
        ? { defaultValue: props.defaultValue }
        : {
            value:
              options.find((o) => sameValue(o.value, props.value)) ||
              (props.value !== "" &&
              props.defaultValue &&
              sameValue(props.defaultValue.value, props.value)
                ? props.defaultValue
                : null),
          };
    return (
      <Autocomplete
        {...controlledProps}
        placeholder={props.placeholder}
        noOptionsText={"Sonuç bulunamadı..."}
        onChange={props.onChange}
        options={options}
        getOptionLabel={(option) => (option ? option.title : "")}
        getOptionSelected={(option, value) => sameValue(option.value, value.value)}
        style={{
          backgroundColor: "white",
          width: "100%",
          borderRadius: "12px",
          borderWidth: "1px",
          minHeight: "50px",
          fontSize: "24px",
        }}
        renderInput={(params) => <TextField {...params} variant="outlined" />}
      />
    );
  }

  return (
    <El
      className={[classNames.input, select ? classNames.select : ""].join(" ")}
      {...props}
    />
  );
};

const Input = ({ label, labelColor, warning, ...props }) =>
  label ? (
    <Label label={label} warning={warning} color={labelColor}>
      <InputElement {...props} label={label} />
    </Label>
  ) : (
    <InputElement {...props} />
  );

export default Input;
